<template>
  <v-autocomplete
    v-model="cliente"
    :items="clientes"
    item-text="Fantasia"
    return-object
    menu-props="auto"
    hide-details
    prepend-inner-icon="search"
    clearable
    open-on-clear
    class="mb-3"
    no-data-text="Nenhum registro encontrado."
    auto-select-first
    autofocus
    @change="searchClient"
  ></v-autocomplete>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "SearchClient",
  data() {
    return {
      cliente: null
    };
  },
  computed: {
    ...mapGetters(["clientes"])
  },
  methods: {
    ...mapActions(['fetchClientes']),
    searchClient() {
      if (this.cliente) this.$emit("searchClient", this.cliente.IdCliente);
    }
  },
  created() {
    if (!this.clientes.length) {
      this.fetchClientes();
    }
  }
};
</script>

<style>
</style>